/**
 * @file 管理切换路由时 需要设置的状态
 */
// eslint-disable-next-line
// @ts-nocheck

// import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { pinia } from '@/store';
import { getOriginPath } from '@/lang/i18n';
import { useSpotStore } from '@/store/spot';
import { useConfigStore } from '@/store/config';
import { useLayoutStore } from '@/store/layout';
import { useTokenStore } from '@/store/token';
import { useActivityStore } from '@/store/activity';
import { supportLang, getLanguage } from '@/lang/i18n';
// import { createRTCPeerConnection } from '@/utils/rtc';
import { supportLanguagesMap } from '@/config/site';
import cookiePlus from '@/utils/cookiePlus';
// import { setKeywords, setDescription } from '@/utils/tdk';

export default {
  beforeEach: [
    async({ matched: toMatched, meta, path, params, query }: RouteLocationNormalized, { matched: fromMatched, path: fromPath, meta: fromMeta, query: fromQuery }: RouteLocationNormalized, next: NavigationGuardNext): void => {
      const spotStore = useSpotStore(pinia);
      const configStore = useConfigStore(pinia);
      const tokenStore = useTokenStore(pinia);
      const activityStore = useActivityStore(pinia);
      const pathLang = path.split('/')[1];
      const fromPathLang = fromPath.split('/')[1];

      // 交易页交易对tab切换状态重置
      if (['/spot', '/spot/:symbolPath'].includes(getOriginPath(toMatched[0]?.path))) {
        if (!['/spot', '/spot/:symbolPath'].includes(getOriginPath(fromMatched[0]?.path))) {
          spotStore.switchSymbolTabEnable = true;
        }
      }

      // ssr 状态预加载
      if (import.meta.env.SSR) {
        const preloadList = meta?.ssg?.preload || [];
        for (const preload of preloadList) {
          if (typeof preload === 'function') {
            await preload();
          }
        }

        // ssg生成页面时的前置数据
        if (meta?.ssg && getOriginPath(toMatched[0]?.path) === '/' && pathLang !== fromPathLang && !configStore.homeConfigReady[pathLang.toLowerCase()]) {
          await configStore.getHomeConfig(supportLang(pathLang) ? pathLang.toLowerCase() : '');
        }
      } else if (getOriginPath(path) != '/limit') {

        // 记录虚拟合约交易的from
        if (getOriginPath(toMatched[0]?.path).includes('/demo-futures')
          && ['/lite-perpetual:symbolPath', '/lite-perpetual', '/futures', '/futures:symbolPath'].includes(getOriginPath(fromMatched[0]?.path))) {
          localStorage.setItem('demo-futures-from', getOriginPath(fromMatched[0]?.path));
          configStore.getHideConfig(true);
        }

        // 代理人专属活动页面数据前置处理
        if (getOriginPath(toMatched[0]?.path).includes('/affiliates/exclusive-activities')) {
          await activityStore.getExclusiveActivity(query.invite_code, query.activityId);
        }

        // 全局存 invite code
        if (query.invite_code) {
          sessionStorage.setItem('inviteCode', query.invite_code);
        }
        // 活动页面 全局存储activityId 跟h5不同域名 使用cookie来存储
        if (getOriginPath(path).includes('/activity/t') || getOriginPath(path).includes('/activity/c')) {
          cookiePlus.write({
            name: 'activity_id',
            value: params.id,
            day: 1, // 24小时
            domain: window.location.hostname.split('.').slice(-2).join('.')  // 获取根域名
          });
        }
      }

      // 币种详情页提前请求
      if (getOriginPath(toMatched[0]?.path) === '/price/:symbolPath') {
        if (params.symbolPath) {
          await tokenStore.getTokenInfo(params.symbolPath);
        }
      }

      if (!configStore.isFetchConfig) {
        configStore.getConfig(() => {
          configStore.getTdk(() => {
            const tdk = configStore.tdks || {};
            const pathKey = getOriginPath(path) || '/index';
            const layoutStore = useLayoutStore(pinia);
            layoutStore.pageTitle = tdk?.[pathKey]?.title || meta?.title;
            layoutStore.pageKeywords = tdk?.[pathKey]?.keyword || meta?.keywords;
            layoutStore.pageDescription = tdk?.[pathKey]?.desc || meta?.description;
          });
        });
        configStore.isFetchConfig = true;
      }

      configStore.getHideConfig();

      // 如果是从 demo-futures 页面跳转，更新隐藏配置
      if (getOriginPath(fromMatched[0]?.path).includes('/demo-futures')
        || getOriginPath(fromMatched[0]?.path).includes('/futures-strategy')
        || getOriginPath(fromMatched[0]?.path).includes('/trading-bot')
        || getOriginPath(fromMatched[0]?.path).includes('/strategy-detail')
        || getOriginPath(fromMatched[0]?.path).includes('/assets/future-strategy')
      ) {
        configStore.getHideConfig(true);
      }

      // 通用站内回跳
      if (fromMeta.backPath) {
        // TODO
      }

      next();
    }
  ],
  afterEach: [
    ({ meta, path }) => {
      // tdk 对应路经
      const pathKey = getOriginPath(path) || '/index';
      const layoutStore = useLayoutStore(pinia);
      const configStore = useConfigStore(pinia);
      const tdk = configStore.tdks || {};

      // 初始化route布局及对应参数
      layoutStore.initRouteLayout(meta);

      if (meta.theme) {
        if (typeof meta.theme === 'string') {
          document.documentElement.setAttribute('class', meta.theme);
        }
      } else {
        // 默认 白天 主题
        document.documentElement.setAttribute('class', 'light');
      }

      if (!import.meta.env.SSR) {
        // 滚动条重置
        document.documentElement.scrollTo(0, 0);
        document.body.scrollTo(0, 0);

        // 阿拉伯语、波斯语等从右向左页面兼容
        const langConfig = supportLanguagesMap[getLanguage()];
        if (langConfig && langConfig.direction) {
          document.documentElement.setAttribute('dir', langConfig.direction);
          layoutStore.direction = langConfig.direction;
        }
      }

      // 设置页面 TDK, 优先使用后台自定义的TDK
      layoutStore.pageTitle = tdk?.[pathKey]?.title || meta?.title;
      layoutStore.pageKeywords = tdk?.[pathKey]?.keyword || meta?.keywords;
      layoutStore.pageDescription = tdk?.[pathKey]?.desc || meta?.description;
    }
  ]
};
